import { render } from "./ProfileTeacher.vue?vue&type=template&id=07e5770d&scoped=true"
import script from "./ProfileTeacher.vue?vue&type=script&lang=js"
export * from "./ProfileTeacher.vue?vue&type=script&lang=js"

import "./ProfileTeacher.vue?vue&type=style&index=0&id=07e5770d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e5770d"]])

export default __exports__